// extracted by mini-css-extract-plugin
export default {"-large":"s1j95pOlGCUl2HNSyFUR","container":"YqQ1H8CEp2MBRanDnav_","graphic":"kRQCadeFDJxfy17bDGZw"};